const rankingData = [
  { rank: 1, title: '91免费看片 V8.2.1 最新版', tag: '本周最热', tagColor: 'bg-primary-100 text-primary-700', desc: '支持4K超清播放，新增AI智能推荐引擎，看片体验全面升级' },
  { rank: 2, title: '追剧必备：10款免费看片软件横评', tag: '编辑精选', tagColor: 'bg-accent-100 text-accent-800', desc: '横向对比主流免费视频软件，帮你找到最适合的那一款' },
  { rank: 3, title: '91免费安卓版下载与安装教程', tag: '新手指南', tagColor: 'bg-secondary-100 text-secondary-800', desc: '从下载到安装只需3分钟，图文详解每个步骤' },
  { rank: 4, title: 'iOS用户必看：苹果端免费看片方案', tag: '热门', tagColor: 'bg-primary-100 text-primary-700', desc: '无需越狱，App Store 外便捷安装91免费客户端的app' },
  { rank: 5, title: '2026年7月最新免费看片app推荐', tag: '月度榜单', tagColor: 'bg-accent-100 text-accent-800', desc: '本月口碑最好的免费看片软件大盘点，含下载链接' },
  { rank: 6, title: '电脑端免费看片软件安装全攻略', tag: 'PC教程', tagColor: 'bg-secondary-100 text-secondary-800', desc: 'Windows/Mac双系统支持，大屏看片更过瘾' },
  { rank: 7, title: '免费看片软件安全下载指南', tag: '安全必读', tagColor: 'bg-primary-100 text-primary-700', desc: '认准官方渠道下载91免费软件，远离恶意捆绑与病毒风险' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门榜单</h2>
            <p className="mt-2 text-sm text-foreground-500">最受关注的免费看片内容与软件排行</p>
          </div>
          <span className="hidden sm:flex items-center gap-1.5 text-xs text-foreground-400">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            实时更新
          </span>
        </div>

        <div className="space-y-3">
          {rankingData.map((item) => (
            <a
              key={item.rank}
              href={`#ranking-${item.rank}`}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors group cursor-pointer"
            >
              <span className={`flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center font-heading text-sm font-bold ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">{item.title}</h3>
                  <span className={`flex-shrink-0 text-[10px] px-2 py-0.5 rounded-full font-medium ${item.tagColor}`}>{item.tag}</span>
                </div>
                <p className="mt-1 text-xs text-foreground-500 truncate">{item.desc}</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}